import script from "./Request.vue?vue&type=script&setup=true&lang=ts"
export * from "./Request.vue?vue&type=script&setup=true&lang=ts"

import "./Request.vue?vue&type=style&index=0&id=4f9fa400&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9fa400"]])

export default __exports__